export default __webpack_public_path__ + "static/media/solucao-04.6a86a2d4.webp";